import React from 'react';
import ArrayRailsSides from 'shared/components/parameters/section_panelized/ArrayRailsSides';
import ArrayRailsWidth from 'shared/components/parameters/section_panelized/ArrayRailsWidth';

const ArrayRails = (props) => (
  <div className="row">
    <div className="col-md-6">
      <ArrayRailsSides {...props} />
    </div>
    <div className="col-md-6">
      <ArrayRailsWidth {...props} />
    </div>
  </div>
);

ArrayRails.defaultProps = {
  label: 'Rail Width',
  required: false,
  tooltip: 'All rails have a width of 0.5 inches.',
};

export default ArrayRails;
